module.exports = __webpack_public_path__ + "img/PH.bd6c2f44.svg";